module.exports = __webpack_public_path__ + "img/main-bg.cbc24e93.jpg";